import { Dispatch } from 'react'
import { AiFeature } from '../../../../../models/AiFeature'
import { AiResult } from '../../../../../models/AiResult'
export const NO_RESULT_TEXT = 'No relevant information detected.'

export interface ResultDisplayProps {
  aiFeature: AiFeature
  aiResult: AiResult
  row: number
  collapsed: boolean
  setCollapsed: Dispatch<boolean>
  showEditButtons?: boolean
}

export enum FormattedResultContentType {
  HTML = 'text/html',
  LEXICAL = 'application/x-lexical-editor',
}
